import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LEGACY_MEMBER_URL } from '../Enums/LegacyRedirection';

const PDF_REGEX = /\/pdf\/[^/]+\.pdf$/i;

const usePdfRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const isLoggedIn = Boolean(document.cookie.split('; ').find(row => row.startsWith('token=')));
  useEffect(() => {
    if (PDF_REGEX.test(pathname)) {
      if (!isLoggedIn) {
        // Redirect to login with redirect param
        const redirectUrl = encodeURIComponent(`${pathname}${search}${hash}`);
        window.location.replace(`/login?redirect=${redirectUrl}`);
        return;
      }
      // Build the new URL
      const newUrl = `${LEGACY_MEMBER_URL}${pathname}${search}${hash}`;
      if (window.location.href !== newUrl) {
        window.location.replace(newUrl);
      }
    }
  }, [pathname, search, hash, isLoggedIn]);
};

export default usePdfRedirect; 